// extracted by mini-css-extract-plugin
export var closeButton = "_3b-3";
export var header = "_3b-0";
export var link = "_3b-1";
export var retryButton = "_3b-2";